<template>
  <div>
    <filter-wrapper @submit="submit">
      <div class="filter__row">
        <div class="filter__item">
          <div class="filter__item__body">
            <z-form-input>
              <v-text-field
                v-model="form.name"
                :label="$t('shared.component.filter.search')"
                outlined
                dense
                clearable
                height="30"
              />
            </z-form-input>
          </div>
        </div>
        <div class="d-flex ml-5">
          <div class="filter__item filter__item--button mr-20">
            <v-badge :content="storeCounter" :value="storeCounter" overlap color="info">
              <v-btn type="button" @click="toggleFilter">
                <div :class="group_arrow_class">
                  {{ $t('shared.component.filter.filters') }}
                </div>
              </v-btn>
            </v-badge>
          </div>
          <div class="filter__item filter__item--button">
            <v-btn
              html-type="submit"
              class="white--text"
              color="primary"
              :loading="is_loading"
              @click="submit"
            >
              {{ $t('shared.component.filter.search') }}
            </v-btn>
          </div>
        </div>
      </div>
      <keep-alive>
        <z-filter v-if="needFilterShow" :tags="tags" :form="form" @input="updateData($event)" />
      </keep-alive>
    </filter-wrapper>
  </div>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { StatusesService } from '@administration/services/StatusesService';
  import { ProjectsService } from '@projects/services/ProjectsService';
  import { UsersService } from '@administration/services/UsersService';
  import { parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { mapActions, mapGetters } from 'vuex';
  import { SET_FILTER_COUNT } from '@filter/store';

  export default {
    components: {
      FilterWrapper
    },
    props: {
      with_project_filter: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      numbers: [],
      statesList: [],
      projectsList: [],
      usersList: [],
      needFilterShow: false,
      showExtra: false,
      form: {
        projects_items: [],
        name: '',
        customer_phone: '',
        email: '',
        assigners_items: [],
        state_items: [],
        date: ''
      },
      is_loading: false
    }),
    computed: {
      ...mapGetters('core/auth', ['user']),
      group_arrow_class() {
        return {
          'filter__item--icon': true,
          'filter__item--icon--active': this.needFilterShow
        };
      },
      tags() {
        return [
          {
            label: 'tasks.campaign.filter.name.phone',
            type: 'Input',
            state: 'customer_phone'
          },
          {
            label: 'tasks.campaign.filter.name.executor',
            type: 'SelectList',
            state: 'assigners_items',
            options: this.usersList.map((i) => ({ id: i.id, name: i.name }))
          },
          {
            label: 'tasks.campaign.filter.status.title',
            type: 'SelectList',
            state: 'state_items',
            options: this.statesList.map((i) => ({ id: i.id, name: i.name }))
          },
          {
            label: 'tasks.campaign.filter.name.project',
            type: 'SelectList',
            state: 'projects_items',
            options: this.projectsList.map((i) => ({ id: i.id, name: i.name })),
            hide: this.with_project_filter
          },
          { label: 'shared.component.filter.period', type: 'DateRange', state: 'date' }
        ];
      },

      storeCounter() {
        return this.$store.getters.getCounter;
      }
    },

    created() {
      this.$store.dispatch(SET_FILTER_COUNT, 0);
      this.submit();
    },

    async mounted() {
      if (!this.with_project_filter) {
        await ProjectsService.getList().then((resp) => (this.projectsList = resp.data));
      }

      await StatusesService.getList().then((resp) => (this.statesList = resp.data));

      if (this.user.role != 'user') {
        await UsersService.getList().then((resp) => (this.usersList = resp.data));
      }
    },

    methods: {
      ...mapActions('tasks/table', ['search']),
      updateData({ state, value }) {
        this.form[state] = value;
      },
      onChange(data) {
        this.form.date = data;
      },
      toggleFilter(e) {
        e.preventDefault();
        this.needFilterShow = !this.needFilterShow;
      },

      submit() {
        const { start, end } = parseSearchStateByPeriod(this.form.date);

        const { name, customer_phone, assigners_items, state_items, projects_items } = this.form;
        const assigned_to = assigners_items.map((i) => i.id);

        let project_ids = [];
        if (this.with_project_filter) {
          project_ids = [this.$route.params.project_id];
        } else {
          project_ids = projects_items.map((i) => i.id);
        }
        const task_state_ids = state_items.map((i) => i.id);

        const params = {
          name,
          customer_phone,
          date_from: start,
          date_to: end,
          task_state_ids,
          project_ids,
          assigned_to
        };

        this.is_loading = true;
        this.search(params, true)
          .then(() => {
            this.is_loading = false;
          })
          .catch((error) => {
            this.$noty.server_error(error);
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    }
  };
</script>

<style lang="scss">
  .filter__item {
    &--icon:after {
      transition: all 0.3s;
      transform: rotate(0deg);
      font-family: Ionicons;
      content: '\F116';
      color: $primary;
      display: inline-block;
    }

    &--icon--active:after {
      transform: rotate(-180deg);
    }
  }
</style>
